import { useContext } from "react";
import converNumberToAlphabet from "utils/ConverNumberToAlphabet";
import { v4 as uuidv4 } from "uuid";
import { Checkfield, Icon } from "@utp/react-components-prod";
import EvaluationContext from "features/Evaluation/context";
import { WrapperContent } from "./styled";

const OneOption = () => {
  const { handleOptionOption, sendQuestion, isMinorTablet, question } =
    useContext(EvaluationContext);
  const { answers, content, order, score } = question;

  const divContainer = `flex bg-01 px-6 pb-6 pt-4 rounded-sm  border border-mid-grey-30 text-color-01 ${
    isMinorTablet ? "flex-col-reverse" : ""
  } gap-5`;

  return (
    <div className="mt-12">
      <div className="flex gap-5">
        <div
          className={`${
            isMinorTablet ? "h-11 w-11" : "h-48 w-48"
          } bg-mid-grey-20 flex justify-center items-center rounded-sm`}
          aria-labelledby="question-number"
        >
          <span
            className="text-color-01 font-bold text-body-02"
            id="question-number"
          >
            {order}.
          </span>
        </div>
        <div className="flex-1 ">
          <div className={divContainer}>
            <div
              className="font-normal flex-1 text-color-01 text-body-02"
              aria-labelledby="question-title"
            >
              <WrapperContent
                id="question-title"
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </div>
            <div className="text-color-02 font-bold w-13 text-body-02 text-end">
              {score} punto{score > 1 ? "s" : ""}.
            </div>
          </div>
          <div className="my-10">
            <span className="text-color-01 flex items-center">
              <Icon iconName="check" size={16} className="mr-2" />
              Selecciona <span className="font-bold ml-1">1 alternativa.</span>
            </span>
          </div>
          {answers.map((item, index: number) => (
            <button
            tabIndex={0}
            key={uuidv4()}
            data-testid={`option-${index}`}
            onClick={() => handleOptionOption(item.id)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Space") {
                handleOptionOption(item.id);
              }
            }}
            className="text-color-01 flex gap-8 items-baseline py-4 px-2 focus:bg-slate-50 focus:rounded-sm"
            >
              <div
                className="text-color-01 font-bold w-12"
                aria-labelledby={`option-${converNumberToAlphabet(index)}`}
              >
                <span
                  className="uppercase"
                  id={`option-${converNumberToAlphabet(index)}`}
                >
                  {converNumberToAlphabet(index)}.
                </span>
              </div>
              <div className="flex flex-1" aria-labelledby={`alternative-${item.id}`}>
                {/* @ts-ignore */}
                <Checkfield
                  text={""}
                  value={item.id}
                  type="radio"
                  checked={
                    sendQuestion.answerId === item.id ? "Checked" : "Empty"
                  }
                  aria-labelledby={`opción ${item.id}`}
                />
                <WrapperContent
                  className="text-start leading-snug"
                  id={`alternative-${item.id}`}
                  dangerouslySetInnerHTML={{
                    __html: item.content,
                  }}
                />
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OneOption;
